"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M33.134 11.26l-8.416-8.414a1.068 1.068 0 0 0-1.51 0l-3.717 3.716a1.053 1.053 0 0 0-.147 1.289l8.42 8.42.008-.017.186.184a1.068 1.068 0 0 0 1.51 0l3.667-3.667a1.068 1.068 0 0 0-.001-1.511zM17.462 9.383l-7.877 3.628a2 2 0 0 0-1.011 1.051l-6.6 15.912a1 1 0 0 0 .216 1.09l.523.523 8.156-8.156a1.649 1.649 0 0 1-.037-.254 2 2 0 1 1 2 2 1.668 1.668 0 0 1-.276-.04l-8.142 8.146.593.593a1 1 0 0 0 1.09.217l15.912-6.6a2 2 0 0 0 1.051-1.011l3.628-7.876z" })
);

